module.exports = __webpack_public_path__ + "static/media/Landing_page_Banner_Mobile@2x.b5c4254d.jpg";